<template>
  <v-card class="d-flex flex-column fill-height">
    <!-- EXPAND -->
    <v-row no-gutters>
      <v-col class="d-flex justify-start">
        <v-btn
          icon
          class="mt-2 ml-4"
          @click="$emit('expand')"
        >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <br>
      </v-col>
    </v-row>
    <!-- TITLE -->
    <v-row no-gutters>
      <v-col class="d-flex justify-center">
        <span
          class="text-h6 text-center secondary--text text--lighten-4 px-1"
          style="height: 24px;"
        >Quick access</span>
      </v-col>
    </v-row>
    <!-- QUICKLAUNCH -->
    <v-row
      no-gutters
      class="fill-height overflow-y-auto"
    >
      <v-col>
        <QuickLaunch
          ref="quicklaunch"
          :catalog="catalog"
          @quick:select="$emit('quick:select', $event)"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import QuickLaunch from '@/components/catalog/quicklaunch'
import Catalog from '@/models/catalog'
import { getEntryStyle } from '@/components/utils'

export default {
  name: 'Shortcuts',

  components: {
    QuickLaunch,
  },
  props: {
    catalog: {
      type: Catalog,
      default: null,
    },
  },
  data: () => ({}),
  computed: {},
  methods: {
    getEntryStyle,
  },
}
</script>

<style lang="scss">
</style>